import { Injectable } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { APIService } from 'api/module'
import { MediaPermissionsService } from 'media/services/mediaPermissions.service'
import { SubclipsClipboardService } from 'media/services/subclipsClipboard.service'
import { PanelService } from 'panel/services/panel.service'
import { MediaOperationsService } from '../services/mediaOperations.service'
import { BaseOperation } from './base'
import { NotifyService } from 'common/util/services/notify.service'

@Injectable({ providedIn: 'root' })
class AddToEditorOp extends BaseOperation {
  icon = 'far fa-plus'
  showInSelectionToolbar = true
  showInContextMenu = true
  showInAssetView = true
  supportsMultiple = true
  supportsBundles = true
  weight = 50

  constructor (
    private translate: TranslateService,
    private panel: PanelService,
    private api: APIService,
    private mediaPermissions: MediaPermissionsService,
    private subclipsCliboard: SubclipsClipboardService,
    private notify: NotifyService,
  ) {
    super()
    this.label = this.translate.instant('Add to editor')
  }

  isVisibleForBundle (bundle): boolean {
    return (
      bundle.mainfile &&
      this.mediaPermissions.getPermissionForBundle(bundle)?.showSubclips &&
      !this.panel.active &&
      this.isEnabledForBundle(bundle)
    )
  }

  isEnabledForBundle (bundle): boolean {
    return ['video', 'image', 'audio'].includes(bundle?.asset?.type)
  }

  async runForBundle (bundle, context): Promise<void> {
    const exists = this.subclipsCliboard.items.some(item => {
      return (
        item.bundle?.asset === bundle.asset.id &&
          item.cut.tIn === 0 &&
          item.cut.tOut === (bundle.asset.info?.duration ?? 5)
      )
    })

    if (exists) {
      this.notify.info(this.translate.instant('Added previously'))
      return
    }

    const subclip = await this.api.mediaLibrary.createSubclip({
      subclipUpdate: {
        asset: bundle.asset,
        root: context.root,
        name: bundle.asset.displayName,
        tIn: 0,
        tOut: bundle.asset.info?.duration ?? 5,
      },
    })
    this.subclipsCliboard.add(subclip, bundle)
    this.notify.info(this.translate.instant('Added'))
  }
}

MediaOperationsService.register(AddToEditorOp)
